<template>
	<div>
		<b-card class="recuring-card">
			<span class="card-subtitle mb-2">
				<h4>Signer ce document</h4>
			</span>

			<b-row class="recuring-card__section">
				<b-col cols="4">
					<label> Votre prénom </label>
					<b-input-group>
						<b-form-input v-model="firstname" size="sm" placeholder="Prénom" required />
					</b-input-group>
				</b-col>

				<b-col cols="4">
					<label> Votre nom </label>
					<b-input-group>
						<b-form-input v-model="lastname" size="sm" placeholder="Nom" required />
					</b-input-group>
				</b-col>

				<b-col cols="4">
					<label> Votre e-mail </label>
					<b-input-group>
						<b-form-input v-model="email" size="sm" placeholder="E-mail" required />
					</b-input-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="6">
					<label> Votre numéro de tel. </label>
					<b-input-group>
						<VuePhoneNumberInput
							ref="phoneInput"
							v-model="inputPhone"
							:preferred-countries="['FR', 'BE', 'CH', 'DE', 'IT', 'ES', 'GB', 'US']"
							default-country-code="FR"
							:translations="translations"
							:required="true"
							:error="phoneError"
							@update="updateFormattedNumber"
						/>
					</b-input-group>
				</b-col>

				<b-col cols="6">
					<b-overlay
						:show="loading"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block w-100 h-100"
					>
						<b-container class="w-100 h-100">
							<b-row class="h-100 pb-1" align-v="end" align-h="end">
								<s-button
									type="success"
									:disabled="buttonDisabled"
									@click="sign"
									style="max-width: fit-content;"
								>
								Signer
								</s-button>
							</b-row>
						</b-container>
					</b-overlay>
				</b-col>
			</b-row>
		</b-card>

		<b-card class="A4">
			<div style="position: absolute; top: 10%; text-align: center; left: 41%">
				<b-icon icon="stopwatch" font-scale="3" animation="cylon" />
				<p id="cancel-label">
					Chargement de votre aperçu...
				</p>
			</div>
			<b-img-lazy style="position: relative; z-index: 999" fluid :src="previewUrl" />
		</b-card>
	</div>
</template>

<script>
	import { mapState } from "vuex";
	import { query } from "@sinao/core-js";
	import VuePhoneNumberInput from 'vue-phone-number-input';
	import 'vue-phone-number-input/dist/vue-phone-number-input.css';
	import { validateEmail } from "@/mixins/methods";

	export default {
		name: "Sign",
    	components: { VuePhoneNumberInput },
		data() {
			return {
				documentId: null,
				loading: false,
				firstname: null,
				lastname: null,
				phone: "",
        		inputPhone: null,
				email: null,
				translations: {
					countrySelectorLabel: 'Code pays',
					countrySelectorError: 'Choisir un pays',
					phoneNumberLabel: 'Numéro de téléphone',
					example: 'Exemple :'
				},
       		 	phoneError: false,
			};
		},
		computed: {
			...mapState({
				apiUrl: state => state.app.apiUrl,
				appId: state => state.app.id,
				pageType: state => state.page.type
			}),
			previewUrl() {
				return `${this.apiUrl}/apps/${this.appId}/${this.pageType}/${
					this.documentId
				}/yousign/preview.jpg?timestamp=${new Date().getTime()}`;
			},
			buttonDisabled() {
				if ((this.phone?.length && this.phoneError) || !this.phone?.length) { return true; }
				return !!(!this.firstname?.length || !this.lastname?.length || !validateEmail(this.email));
			}
		},
		mounted() {
			// eslint-disable-next-line compat/compat
			const urlParams = new URLSearchParams(window.location.search);

			this.documentId = urlParams.get("documentId");
		},
		methods: {
			updateFormattedNumber() {
				this.phone = this.$refs.phoneInput._data.results.formattedNumber;
				this.phoneError = !this.$refs.phoneInput._data.results.isValid
			},
			async sign() {
				try {
					const { firstname, lastname, phone, email, documentId } = this;

					if (!firstname || !lastname || !phone || !email || !documentId) {
						return this.$bvToast.toast(`Tous les champs sont obligatoires.`, {
							title: `Erreur d'envoi`,
							variant: "danger",
							solid: true
						});
					}

					this.loading = true;

					const response = await query({
						operationId: "app.documents.sales.signature.create",
						params: {
							appId: this.appId
						},
						data: {
							documentId,
							firstname,
							lastname,
							phone,
							email
						}
					});

					// Remove onbeforeunload
					window.onbeforeunload = null;

					// Redirect
					setTimeout(function() {
						if (window.location == window.parent.location) {
							window.location.href = response.url;
						} else {
							window.parent.location.href = response.url;
						}
					}, 1000);
				} catch (error) {
					if (error.response.data.message.includes("phone")) {
						return this.$bvToast.toast(`Votre numéro de téléphone est invalid.`, {
							title: `Erreur d'envoi`,
							variant: "danger",
							solid: true
						});
					}

					if (error.response.data.message.includes("email")) {
						return this.$bvToast.toast(`Votre adresse e-mail est invalide.`, {
							title: `Erreur d'envoi`,
							variant: "danger",
							solid: true
						});
					}

					console.error(error);
				} finally {
					this.loading = false;
				}
			}
		}
	};
</script>

<style lang="scss">
	@import "../scss/variables.scss";
	@import "../scss/home.scss";

	.recuring-card {
		max-width: 210mm;
		margin: 3em auto;
		font-size: $font-size-normal;
    	width: 100%;

		.col-6 {
			padding-left: 15px;
			padding-right: 15px;
		}

		&__section {
			padding-top: 1em;
			padding-bottom: 1em;

			&:not(:first-of-type) {
				border-top: $border-color thin solid;
			}
		}

		a:hover {
			text-decoration: none;
			color: var(--link-hover);
		}
	}
</style>
